import * as React from 'react';

import { Translate } from 'react-localize-redux';
import { Switch, useRouteMatch, Route, useLocation } from 'react-router-dom';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import { getWidth } from '@components/styles';

import FormContainer from '@components/layout/form-container';
import MotionOpacity from '@components/motion/motion-opacity';
import SidebarWrapper from '@components/layout/sidebar-wrapper';
import SidebarContainer from '@components/layout/sidebar-container';

import SitePreviewCtrl from '@webapp/controllers/artist/artist-profile/preview';
import ArtistSiteSidebarCtrl from '@webapp/controllers/artist-site/artist-site-sidebar';

import ArtistHomePage from './home';
import ArtistMerchPage from './merch';
import ArtistGeneralWebPage from './settings';
import ArtistSiteEditorContainer from './page-container/index';
import CloseButtton from '@components/basics/icons/close-button';
import AppState from '@webapp/store/state';
import { connect } from 'react-redux';
import { SetArtistPreview } from '@webapp/store/tracpage/action-creators';

interface ArtistSitePageProps {
  className?: string;
  isMobile?: boolean;
  isArtistSite?: boolean;
  isArtistPreview?: boolean;
  closePreview: any;
}
const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
  isArtistSite: state.router.location.pathname.startsWith('/artist/page'),
  isArtistPreview: state.tracpage.artistPreview,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  closePreview: () => dispatch(new SetArtistPreview(false)),
});
const ArtistSitePage: React.FC<ArtistSitePageProps> = (props) => {
  const match = useRouteMatch<{ account: string }>();
  const location = useLocation();

  const getTitle = () => {
    const path = location.pathname.split('/').slice(-1)[0];

    switch (path) {
      case 'settings':
        return <Translate id="ARTIST_SITE.SIDEBAR.SETTINGS" />;
      case 'home':
        return <Translate id="ARTIST_SITE.SIDEBAR.HOME" />;
      case 'merch':
        return <Translate id="ARTIST_SITE.SIDEBAR.MERCH" />;
      default:
        return '';
    }
  };

  const getSection = () => {
    const path = location.pathname.split('/').slice(-1)[0];

    switch (path) {
      case 'settings':
        return '';
      case 'home':
        return '';
      case 'merch':
        return 'merch';
      default:
        return '';
    }
  };
  const onClose = () => {
    props?.closePreview();
  };
  return (
    <MotionOpacity className={props.className}>
      <SidebarContainer>
        <SidebarWrapper>
          <ArtistSiteSidebarCtrl />
        </SidebarWrapper>
        {props.isMobile && props.isArtistSite && props.isArtistPreview ? (
          <SitePreviewWrapper
            className={`${
              props.isMobile && props.isArtistSite ? 'is-artist-preview' : ''
            }`}
          >
            <PreviewHeader>
              <span>Page Preview</span> <CloseButtton onClose={onClose} />
            </PreviewHeader>

            <StyledSitePreviewCtrl
              className={`${
                props.isMobile && props.isArtistPreview
                  ? 'is-artist-preview'
                  : ''
              }`}
              section={getSection()}
              pageType="tracpage"
            />
          </SitePreviewWrapper>
        ) : null}
        {props?.isMobile ? null : (
          <SitePreviewWrapper>
            <StyledSitePreviewCtrl section={getSection()} pageType="tracpage" />
          </SitePreviewWrapper>
        )}
        {props.isMobile &&
        props.isArtistSite &&
        props.isArtistPreview ? null : (
          <FormContainer hasSidebar>
            <ArtistSiteEditorContainer
              path={location.pathname.split('/').slice(-1)[0]}
              title={getTitle()}
            >
              <Switch>
                <Route
                  exact
                  path={`${match.path}/settings`}
                  render={() => <ArtistGeneralWebPage />}
                />
                <Route
                  exact
                  path={`${match.path}/home`}
                  render={() => <ArtistHomePage />}
                />
                <Route
                  exact
                  path={`${match.path}/merch`}
                  render={() => <ArtistMerchPage />}
                />
              </Switch>
            </ArtistSiteEditorContainer>
          </FormContainer>
        )}
      </SidebarContainer>
    </MotionOpacity>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ArtistSitePage);

const PreviewHeader = styled.div`
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  position: absolute;
  top: 0;
  right: 0;
  z-index: 100000;
  display: flex;
  gap: 4rem;
  margin-right: 1.5rem;
  align-items: center;
  margin-top: 0.5rem;
  span {
    font-weight: 700;
  }
`;
const SitePreviewWrapper = styled.div`
  &.is-artist-preview {
    pointer-events: auto !important;
  }
  pointer-events: none;
  position: relative;
  @media ${({ theme }) => theme.device.laptopL} {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    max-width: 1440px;
    padding-right: 30px;
    margin-top: calc(${({ theme }) => theme.sizes.navbar} + 60px);
  }

  @media ${({ theme }) => theme.device.desktopL} {
    max-width: 2560px;
  }
`;

const StyledSitePreviewCtrl = styled(SitePreviewCtrl)`
  margin: auto;
  margin-bottom: 20px;
  height: 200vh;
  pointer-events: none;
  &.is-artist-preview {
    pointer-events: auto !important;
  }
  @media ${({ theme }) => theme.device.mobileS} {
    max-width: ${getWidth(6.5)};
  }
  @media ${({ theme }) => theme.device.laptopL} {
    max-width: 264px;
    height: 470px;
    margin-bottom: 0px;
    float: right;
  }
  @media ${({ theme }) => theme.device.tablet} {
    height: 60vh;
    margin-left: calc(${getWidth(5)} + 60px);
  }
  @media ${({ theme }) => theme.device.laptop} {
    height: 60vh;
    margin-left: calc(${getWidth(6)} + 160px);
  }
`;
